import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

function LandingIntro() {
  return (
      <div>
    <div className="landing-intro" id="que-es-Mr-Gen">
      <div className="landing-intro-texts">
        <Typography
          variant="h3"
          component="h1"
          className="landing-title"
          id="landing-intro-h"
        >
        En Mr. GEN transformamos la alimentación con la ciencia del ADN.
        </Typography>
        <Typography
          variant="body1"
          component="p"
          className="landing-p"
          id="landing-intro-p"
        >
        Con un test genético, descubrimos qué alimentos, minerales y vitaminas asimilás mejor o peor, y te guiamos sobre qué preferir, moderar o evitar.
        <br/>
        Nuestros nutricionistas y chefs crean planes saludables, deliciosos y adaptados a tu genética y gustos.
        <br/><br/>
        🔬 Conocé tu ADN. Revolucioná tu alimentación. Sentite mejor.
        </Typography>
      </div>
      <div className="landing-intro-action">
        <div className="landing-intro-decoration">
          <div className="landing-intro-circle-small" />
          <div className="landing-intro-circle-big" />
        </div>
        <div className="landing-intro-button">
          <Button
            color="primary"
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            disableElevation
            href="#como-funciona"
          >
            Cómo funciona?
          </Button>
        </div>
      </div>
    </div>
    
    </div>
    
  );
}

export default LandingIntro;
